export default {"src":"/_next/static/media/data-collection.075ee427.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};